/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TitleInputs */



/**
* | output |
* | --- |
* | "TITLE" |
*
* @param {Ccsl_Export_Header_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_title = /** @type {((inputs?: Ccsl_Export_Header_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("TITRE")
	if (locale === "de") return /** @type {LocalizedString} */ ("TITEL")
	if (locale === "it") return /** @type {LocalizedString} */ ("TITOLO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ЗАГОЛОВОК")
	if (locale === "es") return /** @type {LocalizedString} */ ("TÍTULO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイトル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("TÍTULO")
	return /** @type {LocalizedString} */ ("TITLE")
});